<div class="error-container">
  <mat-icon svgIcon="error-icon"></mat-icon>
  <div class="error-heading">Sorry, an error has occured.</div>
  <p>Sorry, this site can only be viewed via the mobile app.</p>
</div>
<div class="powered-by">
  <img src="../../../../../assets/logos/poweredByEE-inline.png" />
</div>
